"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M40 4H14.3a.5.5 0 0 0-.35.858l7.9 7.728a54.183 54.183 0 0 0-9.379 13.55c-4.786 10.29-3.125 20.382-2.169 20.341 2.752-.12 1.569-3.44 3.365-7.179 4.771-9.931 13.266-15.555 17.29-17.806l8.184 8a.5.5 0 0 0 .85-.358z" })
);

